/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Device_ChangedInputs */



/**
* | output |
* | --- |
* | "Audio device changed successfully" |
*
* @param {Audio_Recorder_Device_ChangedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_device_changed = /** @type {((inputs?: Audio_Recorder_Device_ChangedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Device_ChangedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Périphérique audio changé avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiogerät erfolgreich gewechselt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dispositivo audio modificato correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Аудиоустройство успешно изменено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El dispositivo de audio se cambió correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频设备已成功更换")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオデバイスが正常に変更されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो डिवाइस सफलतापूर्वक बदल दिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Dispositivo de áudio alterado com sucesso")
	return /** @type {LocalizedString} */ ("Audio device changed successfully")
});